import React, { Component } from "react";
import { connect } from "react-redux";
import Carousel from "nuka-carousel";
import styled from "styled-components";
import ActionCreator from "../ActionCreator";
import * as Widget from "./Widget2";
import HotSaleItem from "./HotSaleItem";

class HotSaleSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      products: [],
      itemPerRow: 3
    };
  }

  async componentDidMount() {
    let { appActions } = this.props;

    try {
      let products = await appActions.fetchLimitProducts(21);
      this.setState({ products, fetching: false });
    } catch (err) {
      console.warn(err);
      this.setState({ fetching: false });
    }
  }

  render() {
    let { navActions } = this.props;
    let { fetching, products, itemPerRow } = this.state;

    return (
      <Wrapper>
        <Widget.Row
          justify="space-between"
          css={`
            margin-bottom: 5px;
            max-width: 1035px;
            width: 100%;
            @media screen and (max-width: 600px) {
              justify-content: center;
              margin-bottom: 30px;
              padding: 0px 30px;
            }
          `}
        >
          <Widget.Container
            css={`
              width: 65px;
              @media screen and (max-width: 600px) {
                display: none;
              }
            `}
          />
          <Widget.SectionTitle haveMarginBottom={false}>
            熱門商品
          </Widget.SectionTitle>
          <Widget.SeeMoreButton
            label="探索更多"
            onClick={() => navActions.push("/products")}
            css={`
              @media screen and (max-width: 600px) {
                display: none;
              }
            `}
          />
        </Widget.Row>

        <Widget.Container
          css={`
            max-width: 1220px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            @media screen and (max-width: 600px) {
              display: none;
            }
          `}
        >
          {fetching ? (
            <Widget.Spinner />
          ) : (
            <Carousel
              slidesToScroll={"auto"}
              renderCenterLeftControls={this._renderLeftIcon}
              renderCenterRightControls={this._renderRightIcon}
              renderBottomCenterControls={this._renderBottomDots}
            >
              {this._reconstructItem().map((oneSlide, i) => (
                <OneSlide key={"product-oneSlide" + i}>{oneSlide}</OneSlide>
              ))}
            </Carousel>
          )}
        </Widget.Container>

        <Widget.Container
          css={`
            margin-bottom: 25px;
            width: 100%;
            overflow-x: scroll;

            //hide scroll bar but keep funcationality
            scrollbar-width: none; //Firebox
            -ms-overflow-style: none; //IE and Edge
            ::-webkit-scrollbar {
              //Chrome, Safari and Opera
              display: none;
            }

            @media screen and (min-width: 601px) {
              display: none;
            }
          `}
        >
          <Widget.Container
            css={`
              width: 5200px; //it is a work around! >"<
              display: flex;
              justify-content: flex-start;
            `}
          >
            {fetching ? (
              <Widget.Spinner />
            ) : (
              products.results.map((p, i) => (
                <HotSaleItem
                  key={"item" + i}
                  item={p}
                  css={`
                    margin: 10px 20px;
                    width: 207px;
                  `}
                />
              ))
            )}
          </Widget.Container>
        </Widget.Container>

        <Widget.SeeMoreButton
          label="探索更多"
          onClick={() => navActions.push("/products")}
          css={`
            margin-top: 15px;
            @media screen and (min-width: 601px) {
              display: none;
            }
          `}
        />
      </Wrapper>
    );
  }

  _reconstructItem = () => {
    let { products, itemPerRow } = this.state;
    let result = [];

    products.results.forEach((p, idx, array) => {
      let element = (
        <HotSaleItem
          key={"element" + idx}
          item={p}
          css={`
            margin: 0px 5px;
            width: 305px;
            height: 389px;
            @media screen and (max-width: 1200px) {
              width: 207px;
              height: 280px;
            }
          `}
        />
      );

      if (idx % itemPerRow === 0) {
        result.push([element]);
      } else {
        let pushIndex = result.length - 1;
        result[pushIndex].push(element);
      }
    });

    return result;
  };

  _renderLeftIcon = ({ previousSlide }) => {
    let { mount } = this.state;
    if (mount && window.screen.width <= 600) {
      return false;
    }

    return (
      <IconContainer
        onClick={previousSlide}
        css="margin-left: 10px; transfrom: rotate(180deg); -webkit-transform: rotate(180deg); -moz-transform: rotate(190deg);"
      >
        <img
          src="/images/pages/landing/icon10.png"
          style={{ width: 20, height: 20 }}
        />
      </IconContainer>
    );
  };

  _renderRightIcon = ({ nextSlide }) => {
    let { mount } = this.state;
    if (mount && window.screen.width <= 600) {
      return false;
    }

    return (
      <IconContainer onClick={nextSlide}>
        <img
          src="/images/pages/landing/icon10.png"
          style={{ width: 20, height: 20 }}
        />
      </IconContainer>
    );
  };

  _renderBottomDots = ({ currentSlide }) => {
    return (
      <Widget.Row>
        {this._reconstructItem().map((item, i) => (
          <div
            key={"dot" + i}
            style={{
              margin: 10,
              width: currentSlide === i ? 8 : 6,
              height: currentSlide === i ? 8 : 6,
              borderRadius: "50%",
              background: currentSlide === i ? "#755B42" : "#DBCBBC"
            }}
          />
        ))}
      </Widget.Row>
    );
  };
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;

  @media screen and (max-width: 768px) {
    padding: 15px 5px;
  }
`;

const OneSlide = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0px 35px;
  height: 500px;

  @media screen and (max-width: 1200px) {
    height: 380px;
  }

  :focus {
    outline: none;
  }
`;

const IconContainer = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  border: 0px;
  background-color: transparent;
  width: 40px;
  height: 40px;

  :focus {
    outline: none;
  }

  ${props => props.css || ""};
`;

export default connect(
  null,
  ActionCreator
)(HotSaleSection);
